// import { take, call, put, select } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga/effects';
import storage from 'utils/storage';

import { MAP_CHANGEDTYPE, MAP_MOVED, MAP_CHANGEDMODE } from './constants';

export function* changedType(action) {
  storage.setItem('mapType', action.mapType);
}

export function* changedMode(action) {
  storage.setItem('travelMode', action.travelMode);
}

export function* moved(action) {
  storage.setItem('zoom', action.zoom);
  storage.setItem('center', action.center);
}

// Individual exports for testing
export default function* defaultSaga() {
  yield takeLatest(MAP_CHANGEDTYPE, changedType);
  yield takeLatest(MAP_CHANGEDMODE, changedMode);
  yield takeLatest(MAP_MOVED, moved);
}
